export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Message, Notification} from 'kpc';

export default class extends Component {
    static template = template;

    showMessage() {
        Message.classNamePrefix = 'kd';
        Message.info('Message with classNamePrefix');
    }
    showNotification() {
        Notification.classNamePrefix = 'kd';
        Notification.info({
            title: 'Notification',
            content: 'Notification with classNamePrefix'
        });
    }
}